import {Button} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import {Site} from '../../interfaces/Site';
import ModalFixed from '../common/ModalFixed';
import SitePermissionsEdit from './SitePermissionsEdit';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  pk?: number;
  name?: string;
  item?: Site;
  prefetch?: boolean;
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  onSubmitted?: () => void;
}

const SitePermissionsEditButton = <T extends ComponentType = typeof Button>({
  component,
  componentProps,
  children,
  ...props
}: Props<T>) => {
  const Component = component ?? Button;
  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <Component {...componentProps} onClick={() => setIsOpened(true)}>
        {children}
      </Component>

      {isOpened && (
        <ModalFixed open={isOpened} onClose={() => setIsOpened(false)}>
          <SitePermissionsEdit {...props} onClose={() => setIsOpened(false)} />
        </ModalFixed>
      )}
    </>
  );
};

export default SitePermissionsEditButton;
